import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from '../../store/doBetStore';
import { ExtraBetsCardsSection } from '../extraBetsCardsSection';
import { CombinationBets } from '../combinationBets';
import { FlopCardsBets } from '../flopCardsBets';
import { ExtraBetsHeader } from './extraBetsHeader';
import { ExtraBetsSwitcher } from './extraBetsSwitcher';
import { betResponseCodeByName } from '../../enums/betResponseCode';

export const ExtraBets = observer(({ handleShowExtraBets }) => {
  const { selectedChip, lastBetModel, updateBetsModel, handleNotificationCode } = doBetStore;
  const { activeFreeBet } = freeBetStore;
  const [isCombinations, setIsCombinations] = useState(true);

  const handleDoChip = useCallback(
    ({ betType, groupType }) => {
      if (
        activeFreeBet.id &&
        lastBetModel.betModel &&
        activeFreeBet.remainingCount - lastBetModel.betModel.length === 0
      ) {
        handleNotificationCode(betResponseCodeByName.NotFreeChip);
        return;
      }
      updateBetsModel({
        marketType: betType,
        groupType,
        amount: selectedChip,
      });
    },
    [handleNotificationCode, activeFreeBet, lastBetModel.betModel, selectedChip, updateBetsModel]
  );

  return (
    <div className='extra-bet-wrapper'>
      <div className='extra-bet-container'>
        <div className='extra-bet-container-inner'>
          <ExtraBetsHeader handleShowExtraBets={handleShowExtraBets} />
          <div className='extra-bet-main'>
            <ExtraBetsSwitcher
              isCombinations={isCombinations}
              setIsCombinations={setIsCombinations}
            />
            <div className='extra-bets-main-wrapper'>
              <ExtraBetsCardsSection />
              {isCombinations && <CombinationBets handleDoChip={handleDoChip} />}
              {!isCombinations && <FlopCardsBets handleDoChip={handleDoChip} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
